// extracted by mini-css-extract-plugin
module.exports = {"noop":"PaperCardTitle_noop__1455-","paperCardTitle":"PaperCardTitle_paperCardTitle__2nafz","bordered":"PaperCardTitle_bordered__kgIOA"};